/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuHoursAssociationsBulkInput } from '../../models/menu-hours-associations-bulk-input';
import { MenuHoursAssociationsBulkResult } from '../../models/menu-hours-associations-bulk-result';

export interface MenuHoursGroupAssociationsBulkPost$Params {
  'Active-Tenant-Identifier': string;
  menuId: string;
  hoursId: string;
      body: MenuHoursAssociationsBulkInput
}

export function menuHoursGroupAssociationsBulkPost(http: HttpClient, rootUrl: string, params: MenuHoursGroupAssociationsBulkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuHoursAssociationsBulkResult>> {
  const rb = new RequestBuilder(rootUrl, menuHoursGroupAssociationsBulkPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('menuId', params.menuId, {});
    rb.path('hoursId', params.hoursId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuHoursAssociationsBulkResult>;
    })
  );
}

menuHoursGroupAssociationsBulkPost.PATH = '/menus/{menuId}/hours/{hoursId}/associations/bulk';
